import { AxiosResponse } from 'axios';

import { CompanyEmailResultMessage } from '../../VesselRequisition/types/CompanyEmailResultMessage';
import { RequisitionOptions } from '../../VesselRequisition/types/RequisitionOptions';
import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';

interface RequisitionRequest {
    id: string;
    options: RequisitionOptions;
}

export const downloadVesselRequisitionForVessel = ({
    id,
    options,
}: RequisitionRequest): Promise<AxiosResponse<Blob>> => {
    return authorizedAxiosInstance.get('/v1/vessel-requisitions', {
        params: { vesselIds: id, ...options },
        responseType: 'blob',
    });
};

export const downloadVesselRequisitionForCustomer = ({
    id,
    options,
}: RequisitionRequest): Promise<AxiosResponse<Blob>> => {
    return authorizedAxiosInstance.get('/v1/vessel-requisitions', {
        params: { customerIds: id, ...options },
        responseType: 'blob',
    });
};

export const sendVesselRequisitionToVessel = ({ id, options }: RequisitionRequest): Promise<AxiosResponse> => {
    return authorizedAxiosInstance.post('/v1/vessel-requisitions/email', null, {
        params: { vesselIds: id, ...options },
    });
};

export const sendVesselRequisitionsForCustomer = ({
    id,
    options,
}: RequisitionRequest): Promise<AxiosResponse<CompanyEmailResultMessage>> =>
    authorizedAxiosInstance.post('/v1/vessel-requisitions/email', null, {
        params: { customerIds: id, ...options },
    });
